// アップロード画面を開いた一覧画面。戻り先（パンくず・戻るボタン）をここから決める
export type UploadOrigin = 'millsheets' | 'shearing_certificates'

export const DEFAULT_UPLOAD_ORIGIN: UploadOrigin = 'millsheets'

// URL は手で書き換えられるため、未知の値は黙って既定（ミルシート一覧）へ倒す
export function parseUploadOrigin(value: unknown): UploadOrigin {
  return value === 'shearing_certificates' || value === 'millsheets' ? value : DEFAULT_UPLOAD_ORIGIN
}

// 各一覧の PageHeader の title と一致させる（戻り先の名前がずれないように）
export const UPLOAD_ORIGIN_LABELS: Record<UploadOrigin, string> = {
  millsheets: 'ミルシート',
  shearing_certificates: '加工証明',
}
